import { Image, Link, Text, View } from '@react-pdf/renderer'
import { DateTime } from 'luxon'

import COLORS from '@/constants/colors'

export function Header({
  fullName,
  startDateString,
  endDateString,
  totalTime,
}: {
  fullName: string
  startDateString: string
  endDateString: string
  totalTime: string
}): React.ReactElement {
  return (
    <View>
      <View
        style={{
          backgroundColor: COLORS.teal[50],
          left: '-40px',
          top: '-32px',
          width: '116%',
          paddingHorizontal: '40px',
          paddingTop: '32px',
          paddingBottom: '16px',
        }}
      >
        <View>
          <View style={{ marginBottom: '16px' }}>
            <Image
              src="https://assets.schoolhouse.world/public/logo-full-v2.png"
              style={{ width: '140px' }}
            />
          </View>
          <Text
            style={{
              fontFamily: 'proximanova',
              fontSize: '11px',
              lineHeight: 1.3,
            }}
          >
            {DateTime.local().toLocaleString(DateTime.DATE_FULL)}
            {'\n\n'}To whom it may concern,{'\n\n'}I am pleased to confirm that {fullName} has
            completed {totalTime} of community service as a small-group tutor at Schoolhouse between{' '}
            {startDateString} and {endDateString}. Schoolhouse is a 501(c)(3) organization that
            connects learners from around the world to volunteer tutors for free, small-group
            tutoring sessions over Zoom. If you have any questions, please reach out by email to{' '}
            <Link src="mailto:volunteering@schoolhouse.world">volunteering@schoolhouse.world</Link>.
            {'\n\n'}Best,
          </Text>
          <Image
            src="https://assets.schoolhouse.world/public/certification/matt-signature.png"
            style={{ width: '100px' }}
          />
          <Text
            style={{
              fontFamily: 'proximanova',
              fontSize: '11px',
              lineHeight: 1.3,
            }}
          >
            Matt Wu{'\n'}COO
          </Text>
        </View>
      </View>
    </View>
  )
}
